import { getStorageSync } from '@/utils/storage.js';

/**
 * 检查用户商户认证状态，若未通过认证则跳转到引导页（Web 环境：localStorage + location）
 * @returns {boolean} true 表示需要跳转（未通过认证），false 表示已通过认证、无需跳转
 */
export function checkMerchantStatus(): boolean {
	if (typeof window === 'undefined') return false;

	const userInfo = getStorageSync('userInfo') || getStorageSync('user');

	if (!userInfo || typeof userInfo !== 'object') {
		navigateTo({
			path: '/login',
		});
		return true;
	}

	const merchantStatus = (userInfo as { merchantStatus?: number }).merchantStatus;
	// 0-注册后待认证, 1-认证中, 2-一审通过待二审, 3-审核通过, 4-审核拒绝
	if ([0, 1, 2, 4].includes(merchantStatus)) {
		navigateTo({
			path: '/login/guidePage',
		});
		return true;
	}

	return false;
}
